export function filterPasscode(input: string): string {
  return input.toUpperCase().replace(/[^A-Z0-9]/g, '').trim()
}
